<template>
  <div>
    <Modal
      v-model="lineUpModal"
      width="360"
      footer-hide
      :closable="false"
      :mask-closable="false"
    >
      <p slot="header" style="color: #3bc582; text-align: center">
        <Icon type="ios-information-circle"></Icon>
        <span style="margin-left: 8px">报名提示</span>
      </p>
      <div style="text-align: center; font-size: 20px">
        <p>正在报名中，请耐心等候....</p>
      </div>
    </Modal>

    <Modal
      v-model="signUpModal"
      width="50%"
      :closable="false"
      :styles="{ top: '10%' }"
      class="notice-modal"
    >
      <p slot="header" class="notice-header">
        <Icon type="ios-information-circle"></Icon>
        <span>学员告知书</span>
      </p>
      <div class="notice-content">
        <p class="notice-intro">
          根据上海老年大学同济大学分校(以下简称"学校")相关制度和要求，提请学员注意以下几点。
        </p>
        <ol class="notice-list">
          <li>学员本着自愿报名原则报名学习学校的课程，学员应自觉遵守国家法律法规和学校规章制度，爱护学校设施和财物，遵守课堂纪律。</li>
          <li>学员年龄一般不超过80周岁。个别特殊课程对学员年龄有特殊要求，并在招生简章附件一"招生要求及课程相关说明"注明。</li>
          <li>学员应密切关注和全面了解自己身心等健康状况，能够胜任学校所报课程学习。</li>
          <li>学员在学校学习过程中，须量力而行，以健康安全为重。如出现任何由于身体疾病等导致的后果，责任自负。</li>
          <li>学员报名后不得私下转让、交换名额、顶替上课。一经发现将劝退并不予办理退费手续。</li>
        </ol>
        <p class="notice-footer">
          上海老年大学同济大学分校<br />2024年5月
        </p>
      </div>
      <div slot="footer" class="notice-footer-btns">
        <Button size="large" class="notice-btn" @click="cancelConfirm"
          >取消</Button
        >
        <Button
          type="success"
          class="notice-btn"
          size="large"
          @click="signUpOk"
          :disabled="okButtonDisabled"
          >{{ okButtonText }}</Button
        >
      </div>
    </Modal>

    <!-- 付款  strat-->
    <ApplyModal
      :visible-pay-msg="visiblePayMsg"
      :pay-data="payData"
      type="applyFlow"
      @changeVisiblePayMsg="value => (visiblePayMsg = value)"
    ></ApplyModal>
    <!-- 付款 end-->
    <!-- <Modal v-model="resolutionModal" width="360" footer-hide	:closable="false" :mask-closable="false">
        <p slot="header" style="color:#3BC582;text-align:center">
            <span style="margin-left:8px">提示</span>
        </p>
        <div style="text-align:center;font-size:20px;">
            <p>请在三个工作日内在指定地点进行线下审核，审核通过后进行付款，如未进行审核，报名将取消。</p>
        </div>

    </Modal> -->
  </div>
</template>
<script >
import ApplyModal from "_c/applyModal.vue";

export default {
  data() {
    return {
      payData: [],
      myLeassonData: [],
      totAmount: 0,
      billno: "",
      courseId: "",
      courseName: "",
      lineUpModal: false,
      visiblePayMsg: false,
      isdisabledFn: true,
      visibleInvoiceMsg: false,
      signUpModal: false,
      resolution: null,
      resolutionModal: true,
      countdown: 0,
      countdownTimer: null,
      okButtonDisabled: false,
    };
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 768;
    },
    okButtonText() {
      if (this.countdown > 0) {
        return this.isMobile 
          ? `请阅读(还剩下${this.countdown}秒)`
          : `请阅读学员告知书(还剩下${this.countdown}秒)`;
      }
      return "知晓并同意";
    },
    initialCountdown() {
      return process.env.NODE_ENV === 'production' ? 5 : 1;
    }
  },
  components: {
    ApplyModal,
  },
  methods: {
    applyConfirm(id, name) {
      this.courseId = id;
      this.courseName = name;
      this.signUpModal = true;
      this.handleOk();
      this.$http.get("/retire-school-manage/config/prohibitPayment").then(res=>{
        this.prohibitPayment = res.data.data;
      });
    },
    cancelConfirm() {
      this.signUpModal = false;
      this.handleCancel();
    },
    getMyCourse() {
      var _this = this;
      _this.$http
        .get("retire-school-manage/personal/getNoPayCourse", {
          params: {
            studentId: _this.$store.state.studentId,
          },
        })
        .then((res) => {
          if (res.data.status === 2000) {
            _this.payData = res.data.data;
          } else {
            console.log(res.data.msg);
            _this.$CustomMessageError(res.data.msg);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    signUpOk() {
      if (this.countdown > 0) {
        return;
      }
      this.signUpModal = false;
      this.apply();
    },
    sendNotice(msg) {
      var _this = this;
      if (_this.$store.state.studentId) {
        _this.$http
          .post("retire-school-manage/notice/addSchoolNotice", {
            studentId: _this.$store.state.studentId,
            content: msg,
          })
          .then(function (res) {
            if (res.data.status != 2000) {
              _this.$CustomMessageError(res.data.msg);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        _this.$router.push("/login");
      }
    },
    apply() {
      var _this = this;
      let id = _this.courseId;
      if (_this.$store.state.studentId) {
        _this.$http
          .post("retire-school-manage/personal/signUp", {
            courseId: id,
            studentId: _this.$store.state.studentId,
          })
          .then(function (res) {
            //返回1002 已报过名
            //返回1003 课程名额已满
            //返回2000 排队 每隔两秒获取一次排队状态

            if (res.data.status === 2000) {
              _this.getApplyStatus(id);
            } else if (res.data.status === 1002) {
              _this.$CustomMessageInfo("此课程您已经报名成功，请勿重复报名!");
            } else if (res.data.status === 1003) {
              _this.$CustomMessageWarn("报名人数已满!");
            } else {
              _this.$CustomMessageError(res.data.msg);
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        _this.$router.push("/login");
      }
    },
    getApplyStatus(id) {
      var _this = this;
      _this.$http
        .get("retire-school-manage/personal/getSignUpStatus", {
          params: {
            courseId: id,
            studentId: _this.$store.state.studentId,
          },
        })
        .then(function (res) {
          //  debugger
          if (res.data.status == 2000) {
            let timer = null;
            if (res.data.data == "1"||res.data.data == "3") {
              _this.lineUpModal = false;
              clearTimeout(timer);
              _this.getMyCourse();
              if (res.data.data == "3") {
                _this.$http
                  .get("retire-school-manage/course/getCampusByCourseId", {
                    params: {
                      id: id,
                    },
                  })
                  .then((res) => {
                    if (res.data.status == 2000) {
                      let msg =
                        "您已成功预约" +
                        _this.courseName +
                        "课程名额。请于3个工作日内携带身份证原件、退休证至" +
                        res.data.data.name +
                        "（地点：" +
                        res.data.data.address +
                        "）（同济大学退休教职工需携带校园一卡通）进行线下审核（工作日上班时间：上午9:00-11:00，下午14:00-16:00）；并在审核通过后的次日24点前完成线上缴费，以上任一流程逾期名额自动取消。";
                      _this.$CustomMessageWarn(msg);
                      _this.sendNotice(msg);
                    } else {
                      clearTimeout(timer);
                      _this.$CustomMessageWarn("错误!");
                    }
                  })
                  .catch((err) => {
                    clearTimeout(timer);
                    console.log(err);
                    this.$CustomMessageWarn("错误!");
                  });
              } else {
                let msg =
                  "您已成功预约" +
                  _this.courseName +
                  "课程名额。请于次日24点前完成线上缴费，逾期名额自动取消。";
                _this.sendNotice(msg);
                _this.visiblePayMsg = true;
              }
            } else if (res.data.data == "2") {
              _this.lineUpModal = false;
              clearTimeout(timer);
              _this.$CustomMessageWarn("名额已满!");
            } else if (res.data.data == "0") {
              _this.lineUpModal = true;
              timer = setTimeout(() => {
                _this.getApplyStatus(id);
              }, 2000);
            }
          } else {
            _this.$CustomMessageError(res.data.msg);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    handleOk() {
      this.countdown = this.initialCountdown;
      this.startCountdown();
    },
    handleCancel() {
      this.clearCountdown();
    },
    startCountdown() {
      this.okButtonDisabled = true;
      this.countdownTimer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
          if (this.countdown === 0) {
            this.clearCountdown();
            this.okButtonDisabled = false;
          }
        }
      }, 1000);
    },
    clearCountdown() {
      clearInterval(this.countdownTimer);
    },
  },
};
</script>

<style scoped>
.notice-modal :deep(.ivu-modal) {
  max-width: 800px;
  width: 90% !important;
  margin: 0 auto;
}

.notice-header {
  color: #3bc582;
  text-align: center;
  font-size: 2rem;
  padding-top: 10px;
  height: 50px;
}

.notice-content {
  margin-top: 20px;
  padding: 20px;
  border-radius: 5px;
  text-align: left;
  color: #333;
  font-size: 1.1rem;
  line-height: 1.6;
}

.notice-intro {
  text-indent: 2em;
  margin-bottom: 1.5rem;
}

.notice-list {
  padding-left: 1.5rem;
  margin-bottom: 2rem;
}

.notice-list li {
  margin-bottom: 1rem;
  text-indent: 2em;
}

.notice-footer {
  text-align: right;
  margin-top: 2rem;
  font-size: 1rem;
}

.notice-footer-btns {
  text-align: center;
}

.notice-btn {
  font-size: 20px;
  margin: 0 10px;
}

@media screen and (max-width: 768px) {
  .notice-modal :deep(.ivu-modal) {
    width: 95% !important;
  }

  .notice-header {
    font-size: 1.5rem;
  }

  .notice-content {
    padding: 15px;
    font-size: 1rem;
  }

  .notice-list {
    padding-left: 1rem;
  }

  .notice-footer {
    font-size: 0.9rem;
  }

  .notice-btn {
    font-size: 16px;
    margin: 0 8px;
  }
}

@media screen and (max-width: 480px) {
  .notice-header {
    font-size: 1.6rem;
    padding-top: 5px;
    height: 40px;
  }

  .notice-content {
    padding: 10px;
    font-size: 0.9rem;
  }

  .notice-list li {
    margin-bottom: 0.8rem;
  }

  .notice-btn {
    font-size: 18px;
    padding: 6px 15px;
    margin: 0 5px;
  }

  .notice-footer-btns :deep(.ivu-btn-large) {
    padding: 5px 15px;
    height: auto;
    line-height: 1.5;
  }
}
</style>
